import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

export const SelectWrapper = styled(Box).attrs({
  flexDirection: 'column',
  mb: 4,
  width: '100%',
})``;
